import { Component, OnInit, inject, signal, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ProfileService } from '../../../../services/profile-service';
import { UserProfileVTO } from '../../../../services/profile-service.model';
import { Loading } from "../../../../utils/loading/loading";
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-profile-info',
  standalone: true,
  imports: [CommonModule, Loading],
  templateUrl: './profile-info.html',
    styleUrl: './profile-info.scss',
})
export class ProfileInfo implements OnInit {
  private profileService = inject(ProfileService);
  private router = inject(Router);

  profile = signal<UserProfileVTO | null>(null);
  userRole = signal<string | null>(null);
  loading = signal<boolean>(false);
  errorMessage = signal<string | null>(null);

  menuOpen = signal<boolean>(false);

  get isRtl(): boolean {
    return document.documentElement.dir === 'rtl';
  }

  ngOnInit() {
    this.fetchProfile();
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.menuOpen.set(false);
  }

  toggleMenu() {
    this.menuOpen.set(!this.menuOpen());
  }

  onUpdateProfile() {
    this.menuOpen.set(false);
    const currentUrl = this.router.url;
    if (currentUrl.includes('/admin')) {
      this.router.navigate(['/admin/profile/update']);
    } else {
      this.router.navigate(['/user/profile/update']);
    }
  }
  onChangePassword() {
    this.menuOpen.set(false); 
    const currentUrl = this.router.url;

    if (currentUrl.includes('/admin')) {
        this.router.navigate(['/admin/profile/change-password']);
      } else {
        this.router.navigate(['/user/profile/change-password']);
      }
  }

  onChangeLanguage() {
    this.menuOpen.set(false); 
    const currentUrl = this.router.url;

    if (currentUrl.includes('/admin')) {
        this.router.navigate(['/admin/profile/change-language']);
      } else {
        this.router.navigate(['/user/profile/change-language']);
      }  }

  onDeactivateAccount() {
    this.menuOpen.set(false); 
    this.router.navigate(['/admin/profile/deactivate-account']);
  }

  onDeleteAccount() {
    this.menuOpen.set(false); 
    this.router.navigate(['/admin/profile/delete-account']);
  }

private fetchProfile() {
    this.loading.set(true);
    this.errorMessage.set(null);
    this.profileService.getUserProfile().pipe(
      finalize(() => this.loading.set(false)) 
    ).subscribe({
      next: (res) => {
        this.profile.set(res);
      },
      error: (err) => {
        const isArabic = document.documentElement.lang === 'ar' || this.isRtl;
        this.errorMessage.set(
          err?.message || (isArabic ? 'فشل تحميل الملف الشخصي' : 'Failed to load profile')
        );
      },
    });
  }
}